module.exports = __webpack_public_path__ + "img/OverseaMember47.b096c45c.jpg";